<template>
    <section class="work-period-bar" aria-label="Рабочий период" :aria-busy="loading ? 'true' : 'false'">
        <div class="work-period-bar__context">
            <span>{{ mode }}</span>
            <strong>{{ label }}</strong>
            <small v-if="context">{{ context }}</small>
        </div>
        <slot name="search" />
        <div class="work-period-bar__controls">
            <b-button variant="outline-primary" :disabled="disabled || !previous" aria-label="Предыдущий месяц"
                @click="$emit('change', previous)">‹</b-button>
            <input type="month" :value="month" :disabled="disabled" aria-label="Выбрать рабочий месяц"
                @change="choose($event)">
            <b-button variant="outline-primary" :disabled="disabled || !next" aria-label="Следующий месяц"
                @click="$emit('change', next)">›</b-button>
            <b-button class="work-period-bar__refresh" variant="outline-primary" aria-label="Обновить" :disabled="disabled || loading" @click="$emit('refresh')">
                <span :class="{'work-period-bar__refresh-label--hidden': loading}">Обновить</span>
                <span v-if="loading" class="work-period-bar__refresh-progress" aria-hidden="true"><b-spinner small></b-spinner></span>
            </b-button>
            <slot />
        </div>
        <span class="sr-only" role="status">{{ loading ? `Загружаем ${label.toLocaleLowerCase('ru')}…` : '' }}</span>
        <div v-if="error" class="work-period-bar__error" role="alert">{{ error }}</div>
    </section>
</template>
<script>
import workPeriod from '@/utils/workPeriod';
export default {
    props: {month: String, mode: String, context: String, loading: Boolean, disabled: Boolean, error: String},
    computed: {
        label() { return workPeriod.monthLabel(this.month); },
        previous() { return workPeriod.shiftMonth(this.month, -1); },
        next() { return workPeriod.shiftMonth(this.month, 1); }
    },
    methods: {
        choose(event) {
            const month = workPeriod.validMonth(event.target.value);
            event.target.value = this.month;
            if (month && month !== this.month) this.$emit('change', month);
        }
    }
};
</script>
<style scoped>
.work-period-bar { position: sticky; top: var(--shell-header-height, 0px); z-index: 1010; display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: .65rem 1rem; padding: .75rem 1rem; margin-bottom: 1rem; background: #fff; border: 1px solid #dce5ee; border-radius: .65rem; box-shadow: 0 3px 10px #18324d12; }
.work-period-bar__context { display: flex; flex-wrap: wrap; align-items: baseline; gap: .2rem .7rem; min-width: 0; }
.work-period-bar__context > span { color: #53657b; font-size: .85rem; }
.work-period-bar__context > strong { color: #20314c; font-size: 1.25rem; }
.work-period-bar__context > small { flex-basis: 100%; overflow-wrap: anywhere; color: #40536b; }
.work-period-bar__controls { display: flex; flex-wrap: wrap; align-items: center; gap: .35rem; }
.work-period-bar__controls input { min-width: 0; width: 10rem; height: 2.4rem; border: 1px solid #9faebf; border-radius: .3rem; padding: .3rem; background: #fff; color: #20314c; }
.work-period-bar__refresh { position: relative; }
.work-period-bar__refresh-label--hidden { visibility: hidden; }
.work-period-bar__refresh-progress { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; }
.work-period-bar__refresh-progress .spinner-border { width: 1rem !important; height: 1rem !important; border-width: 2px; }
.work-period-bar__error { flex-basis: 100%; min-width: 0; padding: .5rem .65rem; color: #842029; background: #fff1f2; border: 1px solid #efc8cd; border-radius: .35rem; font-size: .85rem; overflow-wrap: anywhere; }
@media (max-width: 720px) {
    .work-period-bar { padding: .5rem; gap: .4rem; }
    .work-period-bar__controls { width: 100%; }
    .work-period-bar__controls input { flex: 1; width: 7rem; min-width: 7rem; }
    .work-period-bar__controls .btn { padding: .3rem .6rem; }
    .work-period-bar__context > strong { font-size: 1.1rem; }
}
</style>
